import { render, staticRenderFns } from "./forminputs.vue?vue&type=template&id=c20dbc28&scoped=true"
import script from "./forminputs.vue?vue&type=script&lang=js"
export * from "./forminputs.vue?vue&type=script&lang=js"
import style0 from "./forminputs.vue?vue&type=style&index=0&id=c20dbc28&prod&lang=css"
import style1 from "./forminputs.vue?vue&type=style&index=1&id=c20dbc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20dbc28",
  null
  
)

export default component.exports